<nz-page-header nzTitle="Member Bulk Upload" nzSubtitle="Upload a CSV or Excel file to add multiple members at once."></nz-page-header>

<nz-upload
	nzType="drag"
	[nzMultiple]="false"
	[nzCustomRequest]="customUpload"
	[nzShowUploadList]="false">
	<p class="ant-upload-drag-icon">
		<i nz-icon nzType="inbox" ></i>
	</p>
	<p class="ant-upload-text">Click or drag file to this area to upload</p>
</nz-upload>
<ngb-progressbar *ngIf="uploadProgress || uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />
